import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import {
  Table,
  TableContainer,
  Paper,
  TablePagination,
  makeStyles,
} from '@material-ui/core'
import objectPath from 'object-path'
import { DesignContext } from 'contexts/DesignContext'
import { isEmpty } from 'designer/component/action/condition/State'
import { generateString } from 'designer/component/action/Data'
import { useRouteMatch, useLocation } from 'react-router-dom'
import { setApi } from 'designer/component/action/Api'
import httpClient from 'utility/httpClient.util'
import cloneDeep from 'clone-deep'
import ModalTable from 'designer/component/component/ModalTable'
import { onCheckCondition } from 'designer/component/action/condition/Action'
import MTableHead from './table/mtable/MTableHead'
import MTableBody from './table/mtable/MTableBody'
import MTableButton from './table/mtable/MTableButton'
import ActionsComponent from './table/mtable/ActionsComponent'
import { genRefId, getRowId } from './table/action/index'
import { createTableStyle } from './table/Action'
import { checkCrudCondition } from './table/action/Crud'

const FavoriteTable = (props) => {
  let { uischema, config } = props
  let { favoriteDataKey, updateValue, isFavoriteModal } = config

  const match = useRouteMatch()
  const location = useLocation()
  let receivePathParams = match.params
  let urlSearchParams = new URLSearchParams(location.search || [])
  let receiveQueryParams = Object.fromEntries([...urlSearchParams])
  let allParams = { ...receivePathParams, ...receiveQueryParams }

  const tableAction = uischema?.tableAction?.action || []
  const deleteAction = tableAction.find((action) => action.name === 'delete')
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    getCurrentUi,
    isUiChanged,
    setIsUiChanged,
    elementAction,
    currentSearch,
  } = designContext
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  const datasourceValue = objectPath.get(designContext, '@datasource') || {}
  const formData = jsonForm.formData
  let rowSelection =
    objectPath.get(isUiChanged, ['tableSelection', uischema.key]) || []
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true
  const isReadOnly = !isEnable

  const { employeeList, getEmployee } = designContext

  const tableForm =
    objectPath.get(formData, uischema.key) ||
    objectPath.get(formData, uischema.name)
  const editFavorite = objectPath.get(isUiChanged, `editFavorite`) || {}
  const favoriteJsonData =
    objectPath.get(editFavorite, `jsonData.${favoriteDataKey}`) || null

  const [tableColumn, setTableColumn] = useState([])
  const [columnRequire, setColumnRequire] = useState([])
  const [editData, setEditData] = useState({})
  const [tableData, setTableData] = useState([])
  const [openModalTable, setOpenModalTable] = useState(false)
  const [inputSearch, setInputSearch] = useState({})
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [render, setRender] = useState(false)

  const favoriteRow = objectPath.get(isUiChanged, ['favoriteRow', uischema.key])
  const setFavoriteRow = (favoriteRow) => {
    objectPath.set(isUiChanged, ['favoriteRow', uischema.key], favoriteRow)
    objectPath.set(
      isUiChanged,
      ['favoriteTable', uischema.key],
      cloneDeep(tableData || []),
    )
    setIsUiChanged({ ...isUiChanged })
  }

  const stateParent = {
    inputSearch: [inputSearch, setInputSearch],
    tableData: [tableData, setTableData],
    totalCount: [totalCount, setTotalCount],
    loading: [loading, setLoading],
    render: [render, setRender],
    dataRowSelected: [favoriteRow, setFavoriteRow],
  }

  const updateFormData = (tableData) => {
    updateValue('jsonData', {})
    updateValue(`jsonData.${favoriteDataKey}`, tableData)
    setRender(true)
  }

  useEffect(() => {
    if (!tableData) {
      setTableData(tableForm)
    }
  }, [])

  let isUpdateFavorite = objectPath.get(isUiChanged, [
    'isUpdateFavorite',
    uischema.key,
  ])

  useEffect(() => {
    if (!isUpdateFavorite) return
    let favoriteTable = objectPath.get(isUiChanged, [
      'favoriteTable',
      uischema.key,
    ])
    if (!Array.isArray(favoriteTable)) {
      objectPath.del(isUiChanged, ['isUpdateFavorite', uischema.key])
      setIsUiChanged({ ...isUiChanged })
      return
    }
    const nextTableData = cloneDeep(favoriteTable)
    updateFormData(nextTableData)
    setTableData(nextTableData)
    objectPath.set(isUiChanged, ['favoriteTable', uischema.key], nextTableData)
    objectPath.del(isUiChanged, ['isUpdateFavorite', uischema.key])
    setIsUiChanged({ ...isUiChanged })
  }, [isUpdateFavorite])

  let isRender = objectPath.get(isUiChanged, `${uischema.key}.isRender`)

  useEffect(() => {
    let hasEmployee = tableColumnList.find(
      ({ type }) => type === 'userId' || type === 'employeeCode',
    )
    if (jsonForm?.formCode && employeeList.length === 0 && hasEmployee) {
      getEmployee()
    }
  }, [jsonForm?.formCode])

  useEffect(() => {
    if (isRender) {
      let tableData =
        objectPath.get(formData, uischema.name) ||
        objectPath.get(formData, uischema.key) ||
        []
      setTableData(tableData)
      objectPath.del(isUiChanged, [`isRender`, uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [isRender])

  const visibleRowCount = useMemo(() => {
    return (tableData || []).filter((rowData) => {
      return !objectPath.get(rowData, '@isDeleted')
    }).length
  }, [tableData, isRender])

  const count = visibleRowCount

  let isOpenModalTable = objectPath.get(isUiChanged, [
    'openModalTable',
    uischema.key,
  ])
  let modalAction = objectPath.get(isUiChanged, ['modalAction', uischema.key])

  useEffect(() => {
    if (isOpenModalTable) {
      setOpenModalTable(true)
      objectPath.del(isUiChanged, ['openModalTable', uischema.key])
      setIsUiChanged(isUiChanged)
    }
  }, [isOpenModalTable])

  const [rowsPerPage, setRowsPerPage] = useState(uischema?.rowsPerPage || 5)
  const [page, setPage] = useState(0)

  const rowsPerPageOptions = useMemo(() => {
    let array = [5, 10, 20]
    if (uischema?.rowsPerPage) {
      setRowsPerPage(uischema?.rowsPerPage)
      if (!array.includes(uischema?.rowsPerPage)) {
        array.push(uischema?.rowsPerPage)
      }
    }
    return array.sort((a, b) => a - b)
  }, [uischema?.rowsPerPage])

  const [changeSearch, setChangeSearch] = useState(false)
  useEffect(() => {
    if (changeSearch) {
      setChangeSearch(false)
    }
  }, [changeSearch])

  const search = useMemo(() => {
    let search = jsonForm.search || {}
    let searchTable = jsonForm.searchTable || []
    let foundSearch = searchTable.find(
      ({ tableKey }) => tableKey === uischema.key,
    )
    if (foundSearch) {
      search = foundSearch
    } else if (currentSearch?.uiKey && currentSearch?.search) {
      search = currentSearch?.search
      setChangeSearch(currentSearch?.uiKey)
    }
    return search
  }, [currentSearch?.uiKey])

  // Pagination
  const actionState =
    objectPath.get(isUiChanged, ['tableState', uischema.key]) || {}
  const addState = objectPath.get(actionState, 'add')
  const { isPaging, startRow = 0 } = uischema || {}

  const handleChangePage = (event, newPage) => setPage(newPage)
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0) // reset ไปหน้าแรก
  }

  const handleAdd = () => {
    let dataUpdate = [...(tableData || [])]
    let genId = generateString(10)
    let newRow = {}
    objectPath.set(newRow, genRefId, genId)
    objectPath.set(newRow, `@seq`, count + 1)
    tableColumn.forEach((column) => {
      let { field, defaultValue } = column
      objectPath.set(newRow, field, defaultValue)
    })
    dataUpdate.push(newRow)
    setTableData(dataUpdate)
    const totalPages = Math.ceil((count + 1) / rowsPerPage)
    setPage(totalPages - 1)
    updateFormData(dataUpdate)
  }

  const getRowIndex = (dataUpdate, rowData) => {
    let index = -1
    let genId = objectPath.get(rowData, genRefId)
    let rowId = objectPath.get(rowData, columnRefId)
    if (columnRefId && rowId) {
      index = dataUpdate.findIndex((data) => {
        return objectPath.get(data, columnRefId) === rowId
      })
    } else if (genId) {
      index = dataUpdate.findIndex((data) => {
        return objectPath.get(data, genRefId) === genId
      })
    } else {
      index = dataUpdate.findIndex((rowData) => getRowId(rowData) !== rowId)
    }
    return { rowId, genId, index }
  }

  const onEditRow = (rowData) => {
    let dataUpdate = [...(tableData || [])]
    let { index } = getRowIndex(dataUpdate, rowData)
    if (index > -1) {
      objectPath.set(dataUpdate, index, rowData)
      setTableData(dataUpdate)
    }
    updateFormData(dataUpdate)
  }

  const handleDelete = (rowData) => {
    let dataUpdate = [...(tableData || [])]
    let { index } = getRowIndex(dataUpdate, rowData)
    if (index > -1) {
      objectPath.del(dataUpdate, index)
      setTableData(dataUpdate, true)
    }
    updateFormData(dataUpdate)
  }

  const tableColumnList = objectPath.get(uischema, 'tableColumn') || []
  let { action = [], optional = [] } = uischema.tableAction
  let isActiveUpdate = action.find(
    ({ isActive, name }) => isActive && name === 'update',
  )
  let isActiveDelete = action.find(
    ({ isActive, name }) => isActive && name === 'delete',
  )
  let activeIcon = optional.filter(
    ({ actionType }) => actionType === 'showIcon',
  )
  let activeOptional = optional.filter(
    ({ actionType }) => actionType !== 'showIcon',
  )
  let showAction =
    isActiveUpdate ||
    isActiveDelete ||
    activeIcon.length > 0 ||
    activeOptional.length > 0

  const addStartRow = (tableData, diffLength) => {
    if (diffLength > 0) {
      let genId = generateString(10)
      let newRow = {}
      objectPath.set(newRow, genRefId, genId)
      tableColumn.forEach((column) => {
        let { field, defaultValue } = column
        objectPath.set(newRow, field, defaultValue)
      })
      tableData.push(newRow)
      diffLength--
      return addStartRow(tableData, diffLength)
    }
    tableData.map((row, index) => {
      objectPath.set(row, genRefId, generateString(10))
      objectPath.set(row, '@seq', index + 1)
      return row
    })
    return tableData
  }

  const loadTableData = async (action) => {
    let api = setApi(action, formData, { formData, datasourceValue, allParams })
    if (api) {
      let { headers = [] } = action
      let config = {}
      if (headers.length > 0) {
        headers.forEach(({ key, value }) => {
          if (key) {
            objectPath.set(config, `headers.${key}`, value)
          }
        })
      }
      let dataKey = action.data
      return await httpClient
        .get(api, config)
        .then(({ data }) => (data ? objectPath.get(data, dataKey) : []))
        .catch(() => [])
    }
    return []
  }

  const createTableColumn = () => {
    if (!tableColumnList) return []
    let newColumn = []

    let filterColumn = tableColumnList.filter(
      ({ typeField }) => typeField !== 'system',
    )
    filterColumn.forEach((column, index) => {
      let type = column?.typeField || column?.type
      let conditions = column?.conditions || []
      let isHideFromActiveTab = conditions.find(
        ({ valueType, tabKey, value, actionColumn }) => {
          if (valueType !== 'tab') return
          if (actionColumn !== 'hide') return
          let tabUi = getCurrentUi(value, jsonForm.schema, jsonForm.uischema)
          if (tabUi.key === value) {
            let tabName = tabUi.name
            let isActiveTab =
              objectPath.get(isUiChanged, ['activeTab', tabKey]) == tabName
            return isActiveTab
          }
          return
        },
      )
      if (isHideFromActiveTab) return

      if (column?.isLock) {
        column.editable = 'onAdd'
      }
      if (column?.isRequired) {
        column.validate = (rowData) => {
          let value = objectPath.get(rowData, column.field)
          return isEmpty(value) ? { isValid: false } : true
        }
        if (!columnRequire.includes(column.field))
          columnRequire.push(column.field)
      }
      if (column?.field === uischema?.sortField) {
        column.defaultSort = uischema.defaultSort || 'asc'
        column.sorting = true
      } else {
        delete column.defaultSort
      }
      column.type = type
      column = createTableStyle(column, uischema)
      objectPath.set(column, 'tableData.columnOrder', index)
      newColumn.push(column)
    })
    setTableColumn(newColumn)
    setColumnRequire(columnRequire)
  }

  useEffect(createTableColumn, [
    JSON.stringify(tableColumnList),
    uischema.rowPadding,
    uischema.defaultSort,
    uischema.sortField,
    JSON.stringify(rowSelection),
  ])

  useEffect(async () => {
    let tableData = []
    let filterApi = checkCrudCondition({
      action: uischema.loadData,
      designContext,
      allParams,
    })
    if (isFavoriteModal) {
      tableData = tableForm
    } else if (filterApi?.length > 0) {
      let action = filterApi[0]
      tableData = (await loadTableData(action)) || []
    } else {
      tableData =
        objectPath.get(formData, uischema.name) ||
        objectPath.get(formData, uischema.key) ||
        []
    }
    let tableLength = tableData?.length
    if (tableLength < startRow) {
      let diffLength = startRow - tableLength
      tableData = addStartRow(cloneDeep(tableData), diffLength)
    }
    setTableData(tableData)
    onCheckCondition(designContext, formData, uischema.key)
  }, [])

  const useStyles = makeStyles({
    selectRoot: {
      width: 100,
      minWidth: 100,
    },
    selectMenuPaper: {
      width: 100,
      minWidth: 100,
      maxWidth: 100,
    },
    selectMenuList: {
      width: 100,
      minWidth: 100,
      maxWidth: 100,
    },
  })
  const classes = useStyles()

  return (
    <>
      <div
        style={{
          maxHeight: uischema.maxHeight || '100%',
          minHeight: uischema.minHeight || 'auto',
          overflowY: 'auto',
          boxShadow: '1px 1px 6px 0px #d7d7d7',
        }}
      >
        <Paper>
          <MTableButton {...props} handleAdd={handleAdd} />
          <TableContainer>
            <div
              style={{
                maxHeight: uischema.maxHeight || '100%',
                minHeight: uischema.minHeight || 'auto',
                overflowY: 'auto',
              }}
            >
              <Table>
                <MTableHead
                  {...props}
                  tableColumn={tableColumn}
                  showAction={isEnable ?? showAction}
                  isActiveUpdate={isActiveUpdate}
                  isActiveDelete={isActiveDelete}
                  activeIcon={activeIcon}
                  activeOptional={activeOptional}
                  isReadOnly={isReadOnly}
                />
                <MTableBody
                  {...props}
                  isFavoriteModal={isFavoriteModal}
                  favoriteJsonData={favoriteJsonData}
                  search={search}
                  tableData={tableData}
                  setTableData={setTableData}
                  setPage={setPage}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  tableColumn={tableColumn}
                  addState={addState}
                  editData={editData}
                  setEditData={setEditData}
                  showAction={isEnable ?? showAction}
                  isActiveUpdate={isActiveUpdate}
                  isActiveDelete={isActiveDelete}
                  activeIcon={activeIcon}
                  activeOptional={activeOptional}
                  onDeleteRow={handleDelete}
                  onEditRow={onEditRow}
                  isReadOnly={isReadOnly}
                  openModalTable={openModalTable}
                  stateParent={stateParent}
                />
              </Table>
            </div>
          </TableContainer>
          {isPaging && (
            <TablePagination
              component="div"
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              ActionsComponent={ActionsComponent}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    className: classes.selectMenuPaper,
                  },
                  MenuListProps: {
                    className: classes.selectMenuList,
                  },
                },
              }}
            />
          )}
        </Paper>
      </div>
    </>
  )
}

export default FavoriteTable
